import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';

function HelixNebula({ style }) {
    const particles = useRef();

    useEffect(() => {
        generateHelixNebula();
    }, []);

    const generateHelixNebula = () => {
        const positions = new Float32Array(style.count * 3);
        const colors = new Float32Array(style.count * 3);
        const colorInside = new THREE.Color(style.colorInside[0], style.colorInside[1], style.colorInside[2]);
        const colorOutside = new THREE.Color(style.colorOutside[0], style.colorOutside[1], style.colorOutside[2]);

        for (let i = 0; i < style.count; i++) {
            const i3 = i * 3;

            // Spherical distribution with noise for cloud-like appearance
            const radius = style.radius * (1 + 0.2 * Math.random()); // Add variation in radius
            const angle = Math.random() * Math.PI * 2; // Random angle
            const height = (Math.random() - 0.5) * style.height; // Random height within range

            positions[i3] = radius * Math.cos(angle);
            positions[i3 + 1] = height;
            positions[i3 + 2] = radius * Math.sin(angle);

            // Nebula color blending with noise
            const noiseFactor = Math.random() * 0.5 + 0.5; // Add noise for color variation
            const mixedColor = colorInside.clone().lerp(colorOutside, radius / style.radius);

            colors[i3] = mixedColor.r * noiseFactor;
            colors[i3 + 1] = mixedColor.g * noiseFactor;
            colors[i3 + 2] = mixedColor.b * noiseFactor;
        }

        particles.current.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        particles.current.geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));
    };

    return (
        <points ref={particles}>
            <bufferGeometry />
            <pointsMaterial size={0.02} sizeAttenuation={true} depthWrite={true} vertexColors={true} blending={THREE.AdditiveBlending} />
        </points>
    );
}

export default HelixNebula;
